module.exports = __webpack_public_path__ + "static/media/Robb Stark 3.4d381e0c.jpg";